import React from "react";
import CtaBtn from "../UIElements/CtaBtn";
import Icon from "../UIElements/Icons";
import BlogImage from "../../images/blog-holder.png";
import { Link } from "gatsby";

const ctaLabel = {
    Blog: 'Read More',
    Video: 'Watch Now',
    Podcast: 'Listen Now'
}

export default function BlogTile({image, type, date, title, excerpt, link, author, bgColour}) {
    return (
        <div className={`w-[380px] ${bgColour ? bgColour : 'bg-white'} rounded-md p-2`} style={{boxShadow: '0px 2px 4px -2px rgba(0, 0, 0, 0.25)'}}>
            <Link
                to={link}
                >
                {image ? 
                    <img src={image} alt="" className="aspect-3/2 w-full rounded-md object-cover max-h-[283px]"/> : 
                    <img src={BlogImage} alt="" className="aspect-3/2 w-full rounded-md object-cover max-h-[283px]"/>
                }
            </Link>
            <div className="flex flex-1 justify-end -mt-7 mr-4">
                <div className="w-12 h-12 bg-plum-700 rounded-full p-1">
                    <Icon type={type} colour='white' />
                </div>
            </div>
            <div className="mx-4 grid grid-cols-1 gap-2 mt-4 mb-2">
                <div className="text-orange-700 font-light text-sm">{date} {author !== "The Information Lab" ? `| ${author}` : null}</div>
                <div className="text-[#49526A] text-lg font-semibold">{title}</div>
                <div className="text-global-700 text-[15px] font-light h-[90px] max-h-[90px] text-ellipsis overflow-hidden" dangerouslySetInnerHTML={{"__html": excerpt.replace(/<[^>]+>/ig,'')}}/>
                <div className="flex flex-1 justify-end mt-2 ">
                    <CtaBtn colour="plum" label={ctaLabel[type] ? ctaLabel[type] : 'Read More'} link={link} size="small"/>
                </div>
                
            </div>
            
        </div>
    )
}